import { render, staticRenderFns } from "./TransactionReversal.vue?vue&type=template&id=55e3868a&"
import script from "./TransactionReversal.vue?vue&type=script&lang=js&"
export * from "./TransactionReversal.vue?vue&type=script&lang=js&"
import style0 from "./TransactionReversal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports